import { Component, useMemo } from 'react';
import styled from 'styled-components';
import { listActiveBanners } from '../../actions/banners';
import { AUTSlider } from '../index';
import './index.scss';
import { useGetActiveBannersQuery } from '../../services/api/banners';

const StyledImage = styled.img`
  object-fit: cover;
  max-height: 260px;
`;

const settings = {
  arrows: true,
  dots: true,
  infinite: true,
  speed: 500,
  autoplaySpeed: 5000,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0
};

function shiftLeft(arr, n = 1) {
  const len = arr.length;
  const shift = ((n % len) + len) % len;
  return [...arr.slice(shift), ...arr.slice(0, shift)];
}

const BannerSliderFC = ({ auctionType }) => {
  const { data: banners = [] } = useGetActiveBannersQuery(auctionType);

  const shifted = useMemo(() => shiftLeft(banners), [banners]);

  return (
    <div className="banner-slider">
      <AUTSlider settings={settings}>
        {shifted.map(banner => (
          <div key={banner.id}>
            <StyledImage src={banner.image_url} alt="" />
          </div>
        ))}
      </AUTSlider>
    </div>
  );
};

export class BannerSlider extends Component {
  componentWillMount() {
    const { fetchActiveBanners } = this.props;
    fetchActiveBanners();
  }

  settings = {
    arrows: true,
    dots: true,
    infinite: true,
    speed: 500,
    autoplaySpeed: 5000,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  render() {
    const { banners } = this.props;
    return (
      <div className="banner-slider">
        <AUTSlider settings={this.settings}>
          {banners.map(banner => (
            <div key={banner.id}>
              <StyledImage src={banner.image_url} alt="" />
            </div>
          ))}
        </AUTSlider>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  banners: state.banners.activeBanners || []
});

const mapDispatchToProps = dispatch => ({
  fetchActiveBanners: () => dispatch(listActiveBanners().request)
});

export default BannerSliderFC;
